const actionBy = {
  SERVER_FUNCTION: 'server-function',
  SYSTEM: 'SYSTEM',
};

export default actionBy;
